import { useState } from "react"
import nagerApi from "./nagerApi"

const ThisYearHolidays = () => {

    const [dates, setDates] = useState()
    const [error, setError] = useState(null)

    const isPast = (eventDate) => {
        return new Date() > new Date(eventDate)
    }

    function reverseDate(date) {
        if (date != null)
            return date.split("-").reverse().join("-")
    }

    const getDates = async () => {

        try {
            const response = await nagerApi.get("PublicHolidays/2024/IT",
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: false
                }
            );
            console.log(JSON.stringify(response?.data));
            setDates(response?.data)
        } catch (err) {
            console.error("Error: " + err)
        }
    }

    if (dates == null && error == null) {
        getDates()
    }

    let content

    if (dates != null) {
        content =
            <table className="table  table-hover  small">
                <tbody>
                    {
                        dates.map(date => {
                            return <tr key={date.date} className={`${isPast(date.date) ? "opacity-25" : null}`}>
                                <th>{date.localName} </th>
                                <td className={`badge ${isPast(date.date) ? "bg-secondary" : "bg-primary"}`}>{reverseDate(date.date)}</td>

                            </tr >
                        })
                    }

                </tbody>
            </table>
    }
    return content
}

export default ThisYearHolidays

